import { useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { patchReq } from 'api';
import Button from 'components/Button';
import { authSelector, setAuthDetails } from 'store/auth';
import styles from 'styles/modules/AlertNotificationsStatus.module.scss';

const AlertNotificationsStatus = () => {
    const {
        id,
        company,
        isAuthenticated,
        isJournalist,
        deactivated,
        alertNotifications,
    } = useSelector(authSelector);
    const router = useRouter();
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);
    const [failed, setFailed] = useState(false);

    const isOwnPage = isAuthenticated && company === router.query.company;

    // undefined/null means /users/me never resolved. Showing OFF here is what
    // silently unsubscribed members in the first place.
    if (
        !isOwnPage ||
        isJournalist ||
        deactivated ||
        alertNotifications === undefined ||
        alertNotifications === null
    ) {
        return null;
    }

    const isOn = Boolean(alertNotifications);

    const handleToggle = async () => {
        setSaving(true);
        setFailed(false);
        try {
            const { status } = await patchReq(
                `users/${id}/alert-notifications`,
                { alertNotifications: !isOn }
            );
            if (status !== 200 && status !== 201) {
                throw new Error(`Unexpected status ${status}`);
            }
            dispatch(setAuthDetails({ alertNotifications: !isOn }));
        } catch {
            setFailed(true);
        }
        setSaving(false);
    };

    return (
        <div
            className={[
                'mb-m',
                styles.status,
                isOn ? styles.on : styles.off,
            ].join(' ')}
        >
            <div className={styles.body}>
                <span className={styles.label}>
                    News Alerts: {isOn ? 'ON' : 'OFF'}
                </span>
                {!isOn && (
                    <p className={styles.message}>
                        You are not receiving News Alerts, so journalist
                        requests for your expertise are passing you by.
                    </p>
                )}
                {failed && (
                    <p className={styles.error}>
                        We could not change your News Alerts. Please try again.
                    </p>
                )}
            </div>
            {isOn ? (
                <button
                    type="button"
                    onClick={handleToggle}
                    disabled={saving}
                    className={styles.quietAction}
                >
                    Turn off
                </button>
            ) : (
                <Button
                    title={'Turn News Alerts on'}
                    onClick={handleToggle}
                    loading={saving}
                    classes={[styles.action]}
                />
            )}
        </div>
    );
};

export default AlertNotificationsStatus;
